/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MarketplaceRouteImport } from './routes/marketplace'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MarketplaceProductIdRouteImport } from './routes/marketplace.$productId'
import { Route as AuthPluginRouteImport } from './routes/auth/plugin'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedDownloadsRouteImport } from './routes/_authenticated/downloads'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCreatorsRouteImport } from './routes/_authenticated/creators'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedCreatorsIndexRouteImport } from './routes/_authenticated/creators/index'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedCreatorsPublishRouteImport } from './routes/_authenticated/creators/publish'
import { Route as AuthenticatedCreatorsProductsRouteImport } from './routes/_authenticated/creators/products'
import { Route as AuthenticatedCreatorsOrdersRouteImport } from './routes/_authenticated/creators/orders'
import { Route as AuthenticatedCreatorsLicensesRouteImport } from './routes/_authenticated/creators/licenses'
import { Route as AuthenticatedCreatorsAnalyticsRouteImport } from './routes/_authenticated/creators/analytics'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin/users'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin/settings'
import { Route as AuthenticatedAdminProductsRouteImport } from './routes/_authenticated/admin/products'
import { Route as AuthenticatedAdminLicensesRouteImport } from './routes/_authenticated/admin/licenses'
import { Route as AuthenticatedAdminAnalyticsRouteImport } from './routes/_authenticated/admin/analytics'

const MarketplaceRoute = MarketplaceRouteImport.update({
  id: '/marketplace',
  path: '/marketplace',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketplaceProductIdRoute = MarketplaceProductIdRouteImport.update({
  id: '/$productId',
  path: '/$productId',
  getParentRoute: () => MarketplaceRoute,
} as any)
const AuthPluginRoute = AuthPluginRouteImport.update({
  id: '/auth/plugin',
  path: '/auth/plugin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDownloadsRoute = AuthenticatedDownloadsRouteImport.update({
  id: '/downloads',
  path: '/downloads',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCreatorsRoute = AuthenticatedCreatorsRouteImport.update({
  id: '/creators',
  path: '/creators',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCreatorsIndexRoute =
  AuthenticatedCreatorsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCreatorsRoute,
  } as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedCreatorsPublishRoute =
  AuthenticatedCreatorsPublishRouteImport.update({
    id: '/publish',
    path: '/publish',
    getParentRoute: () => AuthenticatedCreatorsRoute,
  } as any)
const AuthenticatedCreatorsProductsRoute =
  AuthenticatedCreatorsProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedCreatorsRoute,
  } as any)
const AuthenticatedCreatorsOrdersRoute =
  AuthenticatedCreatorsOrdersRouteImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => AuthenticatedCreatorsRoute,
  } as any)
const AuthenticatedCreatorsLicensesRoute =
  AuthenticatedCreatorsLicensesRouteImport.update({
    id: '/licenses',
    path: '/licenses',
    getParentRoute: () => AuthenticatedCreatorsRoute,
  } as any)
const AuthenticatedCreatorsAnalyticsRoute =
  AuthenticatedCreatorsAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedCreatorsRoute,
  } as any)
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminSettingsRoute =
  AuthenticatedAdminSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminProductsRoute =
  AuthenticatedAdminProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminLicensesRoute =
  AuthenticatedAdminLicensesRouteImport.update({
    id: '/licenses',
    path: '/licenses',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAnalyticsRoute =
  AuthenticatedAdminAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/marketplace': typeof MarketplaceRouteWithChildren
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/creators': typeof AuthenticatedCreatorsRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/downloads': typeof AuthenticatedDownloadsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/auth/plugin': typeof AuthPluginRoute
  '/marketplace/$productId': typeof MarketplaceProductIdRoute
  '/admin/analytics': typeof AuthenticatedAdminAnalyticsRoute
  '/admin/licenses': typeof AuthenticatedAdminLicensesRoute
  '/admin/products': typeof AuthenticatedAdminProductsRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/creators/analytics': typeof AuthenticatedCreatorsAnalyticsRoute
  '/creators/licenses': typeof AuthenticatedCreatorsLicensesRoute
  '/creators/orders': typeof AuthenticatedCreatorsOrdersRoute
  '/creators/products': typeof AuthenticatedCreatorsProductsRoute
  '/creators/publish': typeof AuthenticatedCreatorsPublishRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/creators/': typeof AuthenticatedCreatorsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/marketplace': typeof MarketplaceRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/downloads': typeof AuthenticatedDownloadsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/auth/plugin': typeof AuthPluginRoute
  '/marketplace/$productId': typeof MarketplaceProductIdRoute
  '/admin/analytics': typeof AuthenticatedAdminAnalyticsRoute
  '/admin/licenses': typeof AuthenticatedAdminLicensesRoute
  '/admin/products': typeof AuthenticatedAdminProductsRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/creators/analytics': typeof AuthenticatedCreatorsAnalyticsRoute
  '/creators/licenses': typeof AuthenticatedCreatorsLicensesRoute
  '/creators/orders': typeof AuthenticatedCreatorsOrdersRoute
  '/creators/products': typeof AuthenticatedCreatorsProductsRoute
  '/creators/publish': typeof AuthenticatedCreatorsPublishRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/creators': typeof AuthenticatedCreatorsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/marketplace': typeof MarketplaceRouteWithChildren
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/creators': typeof AuthenticatedCreatorsRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/downloads': typeof AuthenticatedDownloadsRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/auth/plugin': typeof AuthPluginRoute
  '/marketplace/$productId': typeof MarketplaceProductIdRoute
  '/_authenticated/admin/analytics': typeof AuthenticatedAdminAnalyticsRoute
  '/_authenticated/admin/licenses': typeof AuthenticatedAdminLicensesRoute
  '/_authenticated/admin/products': typeof AuthenticatedAdminProductsRoute
  '/_authenticated/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/_authenticated/admin/users': typeof AuthenticatedAdminUsersRoute
  '/_authenticated/creators/analytics': typeof AuthenticatedCreatorsAnalyticsRoute
  '/_authenticated/creators/licenses': typeof AuthenticatedCreatorsLicensesRoute
  '/_authenticated/creators/orders': typeof AuthenticatedCreatorsOrdersRoute
  '/_authenticated/creators/products': typeof AuthenticatedCreatorsProductsRoute
  '/_authenticated/creators/publish': typeof AuthenticatedCreatorsPublishRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/creators/': typeof AuthenticatedCreatorsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/marketplace'
    | '/admin'
    | '/creators'
    | '/dashboard'
    | '/downloads'
    | '/profile'
    | '/auth/plugin'
    | '/marketplace/$productId'
    | '/admin/analytics'
    | '/admin/licenses'
    | '/admin/products'
    | '/admin/settings'
    | '/admin/users'
    | '/creators/analytics'
    | '/creators/licenses'
    | '/creators/orders'
    | '/creators/products'
    | '/creators/publish'
    | '/admin/'
    | '/creators/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/marketplace'
    | '/dashboard'
    | '/downloads'
    | '/profile'
    | '/auth/plugin'
    | '/marketplace/$productId'
    | '/admin/analytics'
    | '/admin/licenses'
    | '/admin/products'
    | '/admin/settings'
    | '/admin/users'
    | '/creators/analytics'
    | '/creators/licenses'
    | '/creators/orders'
    | '/creators/products'
    | '/creators/publish'
    | '/admin'
    | '/creators'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/marketplace'
    | '/_authenticated/admin'
    | '/_authenticated/creators'
    | '/_authenticated/dashboard'
    | '/_authenticated/downloads'
    | '/_authenticated/profile'
    | '/auth/plugin'
    | '/marketplace/$productId'
    | '/_authenticated/admin/analytics'
    | '/_authenticated/admin/licenses'
    | '/_authenticated/admin/products'
    | '/_authenticated/admin/settings'
    | '/_authenticated/admin/users'
    | '/_authenticated/creators/analytics'
    | '/_authenticated/creators/licenses'
    | '/_authenticated/creators/orders'
    | '/_authenticated/creators/products'
    | '/_authenticated/creators/publish'
    | '/_authenticated/admin/'
    | '/_authenticated/creators/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  MarketplaceRoute: typeof MarketplaceRouteWithChildren
  AuthPluginRoute: typeof AuthPluginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/marketplace': {
      id: '/marketplace'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof MarketplaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketplace/$productId': {
      id: '/marketplace/$productId'
      path: '/$productId'
      fullPath: '/marketplace/$productId'
      preLoaderRoute: typeof MarketplaceProductIdRouteImport
      parentRoute: typeof MarketplaceRoute
    }
    '/auth/plugin': {
      id: '/auth/plugin'
      path: '/auth/plugin'
      fullPath: '/auth/plugin'
      preLoaderRoute: typeof AuthPluginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/downloads': {
      id: '/_authenticated/downloads'
      path: '/downloads'
      fullPath: '/downloads'
      preLoaderRoute: typeof AuthenticatedDownloadsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/creators': {
      id: '/_authenticated/creators'
      path: '/creators'
      fullPath: '/creators'
      preLoaderRoute: typeof AuthenticatedCreatorsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/creators/': {
      id: '/_authenticated/creators/'
      path: '/'
      fullPath: '/creators/'
      preLoaderRoute: typeof AuthenticatedCreatorsIndexRouteImport
      parentRoute: typeof AuthenticatedCreatorsRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/creators/publish': {
      id: '/_authenticated/creators/publish'
      path: '/publish'
      fullPath: '/creators/publish'
      preLoaderRoute: typeof AuthenticatedCreatorsPublishRouteImport
      parentRoute: typeof AuthenticatedCreatorsRoute
    }
    '/_authenticated/creators/products': {
      id: '/_authenticated/creators/products'
      path: '/products'
      fullPath: '/creators/products'
      preLoaderRoute: typeof AuthenticatedCreatorsProductsRouteImport
      parentRoute: typeof AuthenticatedCreatorsRoute
    }
    '/_authenticated/creators/orders': {
      id: '/_authenticated/creators/orders'
      path: '/orders'
      fullPath: '/creators/orders'
      preLoaderRoute: typeof AuthenticatedCreatorsOrdersRouteImport
      parentRoute: typeof AuthenticatedCreatorsRoute
    }
    '/_authenticated/creators/licenses': {
      id: '/_authenticated/creators/licenses'
      path: '/licenses'
      fullPath: '/creators/licenses'
      preLoaderRoute: typeof AuthenticatedCreatorsLicensesRouteImport
      parentRoute: typeof AuthenticatedCreatorsRoute
    }
    '/_authenticated/creators/analytics': {
      id: '/_authenticated/creators/analytics'
      path: '/analytics'
      fullPath: '/creators/analytics'
      preLoaderRoute: typeof AuthenticatedCreatorsAnalyticsRouteImport
      parentRoute: typeof AuthenticatedCreatorsRoute
    }
    '/_authenticated/admin/users': {
      id: '/_authenticated/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthenticatedAdminUsersRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/settings': {
      id: '/_authenticated/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AuthenticatedAdminSettingsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/products': {
      id: '/_authenticated/admin/products'
      path: '/products'
      fullPath: '/admin/products'
      preLoaderRoute: typeof AuthenticatedAdminProductsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/licenses': {
      id: '/_authenticated/admin/licenses'
      path: '/licenses'
      fullPath: '/admin/licenses'
      preLoaderRoute: typeof AuthenticatedAdminLicensesRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/analytics': {
      id: '/_authenticated/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AuthenticatedAdminAnalyticsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminAnalyticsRoute: typeof AuthenticatedAdminAnalyticsRoute
  AuthenticatedAdminLicensesRoute: typeof AuthenticatedAdminLicensesRoute
  AuthenticatedAdminProductsRoute: typeof AuthenticatedAdminProductsRoute
  AuthenticatedAdminSettingsRoute: typeof AuthenticatedAdminSettingsRoute
  AuthenticatedAdminUsersRoute: typeof AuthenticatedAdminUsersRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAnalyticsRoute: AuthenticatedAdminAnalyticsRoute,
  AuthenticatedAdminLicensesRoute: AuthenticatedAdminLicensesRoute,
  AuthenticatedAdminProductsRoute: AuthenticatedAdminProductsRoute,
  AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,
  AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedCreatorsRouteChildren {
  AuthenticatedCreatorsAnalyticsRoute: typeof AuthenticatedCreatorsAnalyticsRoute
  AuthenticatedCreatorsLicensesRoute: typeof AuthenticatedCreatorsLicensesRoute
  AuthenticatedCreatorsOrdersRoute: typeof AuthenticatedCreatorsOrdersRoute
  AuthenticatedCreatorsProductsRoute: typeof AuthenticatedCreatorsProductsRoute
  AuthenticatedCreatorsPublishRoute: typeof AuthenticatedCreatorsPublishRoute
  AuthenticatedCreatorsIndexRoute: typeof AuthenticatedCreatorsIndexRoute
}

const AuthenticatedCreatorsRouteChildren: AuthenticatedCreatorsRouteChildren = {
  AuthenticatedCreatorsAnalyticsRoute: AuthenticatedCreatorsAnalyticsRoute,
  AuthenticatedCreatorsLicensesRoute: AuthenticatedCreatorsLicensesRoute,
  AuthenticatedCreatorsOrdersRoute: AuthenticatedCreatorsOrdersRoute,
  AuthenticatedCreatorsProductsRoute: AuthenticatedCreatorsProductsRoute,
  AuthenticatedCreatorsPublishRoute: AuthenticatedCreatorsPublishRoute,
  AuthenticatedCreatorsIndexRoute: AuthenticatedCreatorsIndexRoute,
}

const AuthenticatedCreatorsRouteWithChildren =
  AuthenticatedCreatorsRoute._addFileChildren(
    AuthenticatedCreatorsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedCreatorsRoute: typeof AuthenticatedCreatorsRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedDownloadsRoute: typeof AuthenticatedDownloadsRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedCreatorsRoute: AuthenticatedCreatorsRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedDownloadsRoute: AuthenticatedDownloadsRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface MarketplaceRouteChildren {
  MarketplaceProductIdRoute: typeof MarketplaceProductIdRoute
}

const MarketplaceRouteChildren: MarketplaceRouteChildren = {
  MarketplaceProductIdRoute: MarketplaceProductIdRoute,
}

const MarketplaceRouteWithChildren = MarketplaceRoute._addFileChildren(
  MarketplaceRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  MarketplaceRoute: MarketplaceRouteWithChildren,
  AuthPluginRoute: AuthPluginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
